import styles from "./styles/QurealSpotlight.module.css";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { Button, Input } from "antd";
import { SearchOutlined, ThunderboltOutlined } from "@ant-design/icons";
import { useItemsFine } from "../actions/app/items";
import log from "cslog";
import { getImageFileURL, getImageURL } from "../_helpers/image";
import PreviewTemplate from "../qmade/creator/PreviewTemplate";
import useMedia from "react-use/lib/useMedia";
import { useDebounce } from "../utils/input";
import snakeCase from "lodash/snakeCase";
import classNames from "classnames";
import QurealLightCore from "./QurealLightCore";

const FIELDS =
    "id,type,title,preview.id,preview.filename_disk,tags.qdb_tag_id.*,inputs,used_schemas.qdb_creation_schema_id.id,used_schemas.qdb_creation_schema_id.name,used_schemas.qdb_creation_schema_id.user_prompt_question";

function QurealSpotlight({ me, externalOpen, onClose, noIcon = false }) {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (externalOpen > 0) setOpen(true);
    }, [externalOpen]);
    const [selected_item, setSelectedItem] = useState(null);
    const [open_preview, setOpenPreview] = useState(false);
    const isMobile = useMedia("(max-width: 700px)");

    const inputRef = useRef(null);

    useEffect(() => {
        if (open) {
            setSelectedItem(null);
            inputRef.current?.focus({
                cursor: "all",
            });
        }
    }, [open]);

    useEffect(() => {
        if (!open_preview && selected_item?.type) {
            setOpen(true);
        }
    }, [open_preview]);

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === "Escape") {
                console.log("Close");
                setOpen(false);
            }
        };
        window.addEventListener("keydown", handleEsc);
        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            // Check for Ctrl+K or Cmd+K
            if (
                (event.ctrlKey || event.metaKey) &&
                event.key.toLowerCase() === "k"
            ) {
                event.preventDefault();
                setOpen(true);
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    return (
        <Fragment>
            <div className={styles.trigger_wrapper}>
                {isMobile ? (
                    !noIcon && (
                        <SearchOutlined
                            onClick={() => setOpen(true)}
                            style={{
                                fontSize: "22px",
                                color: "gray",
                            }}
                        />
                    )
                ) : (
                    <Button
                        type="ghost"
                        ghost
                        // icon={<ThunderboltOutlined />}
                        icon={<SearchOutlined />}
                        // className={styles.ai_btn}
                        className={styles.btn_grad}
                        onClick={() => setOpen(true)}
                    >
                        Spotlight
                    </Button>
                )}
            </div>
            {/* <p>Me: {JSON.stringify(me)}</p> */}
            {/* <Button
            ghost onClick={() => setOpen(true)}
            icon={<SearchOutlined />}
        >Qureal Light</Button> */}
            {open && (
                <div
                    className={classNames(styles.body_wrapper, {
                        [styles.body_wrapper_mobile]: isMobile,
                    })}
                    onClick={() => {
                        if (!selected_item?.type) {
                            setOpen(false);
                        } else {
                            setOpen(true);
                        }
                    }}
                >
                    <QurealLightCore
                        open={open}
                        setOpen={setOpen}
                        isMobile={isMobile}
                        me={me}
                        selected_item={selected_item}
                        setSelectedItem={setSelectedItem}
                        open_preview={open_preview}
                        setOpenPreview={setOpenPreview}
                        is_spot={true}
                        inputRef={inputRef}
                    />
                </div>
            )}
        </Fragment>
    );
}

export default QurealSpotlight;
